import React, { useState } from 'react';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-[#0a0e27] py-6 md:py-8 px-4 font-sans" data-id="element-74">
      <div className="max-w-3xl mx-auto" data-id="element-75">
        <h2 className="text-3xl md:text-5xl font-extrabold text-center mb-5 flex items-center justify-center gap-3" data-id="element-76">
          <span className="text-3xl md:text-5xl" data-id="element-77">❓</span>
          <span data-id="element-78">
            <span className="text-white" data-id="element-79">PREGUNTAS </span>
            <span className="text-[#22c55e]" data-id="element-80">FRECUENTES</span>
          </span>
        </h2>

        <div className="space-y-2" data-id="element-81">
          {/* FAQ 1 */}
          <div className="bg-[#111638] border border-gray-800 rounded-lg overflow-hidden transition-all duration-200" data-id="element-82">
            <button onClick={() => setOpenIndex(openIndex === 0 ? null : 0)} className="w-full flex items-center justify-between p-3 md:p-4 text-left group" data-id="element-83">
              <div className="flex items-center gap-3 flex-1" data-id="element-84">
                <span className="text-[#22c55e] font-bold text-sm md:text-base whitespace-nowrap" data-id="element-85">
                  1 —
                </span>
                <span className="font-bold text-white text-sm md:text-base" data-id="element-86">
                  ¿Cómo recibo el Kit después de comprar?
                </span>
              </div>
              <span className="text-gray-500 ml-3 flex-shrink-0 text-xs" data-id="element-87">
                {openIndex === 0 ? '▲' : '▼'}
              </span>
            </button>
            {openIndex === 0 && <div className="px-3 md:px-4 pb-3 md:pb-4 pt-0 ml-10 md:ml-12" data-id="element-88">
                <p className="text-gray-400 text-sm md:text-base leading-relaxed border-t border-gray-800 pt-3" data-id="element-89">
                  Inmediatamente después del pago recibís un email con el link
                  de descarga. En menos de 5 minutos ya tenés todo descargado en
                  tu dispositivo. 100% PDF, sin apps ni plataformas extras.
                </p>
              </div>}
          </div>

          {/* FAQ 2 */}
          <div className="bg-[#111638] border border-gray-800 rounded-lg overflow-hidden transition-all duration-200" data-id="element-90">
            <button onClick={() => setOpenIndex(openIndex === 1 ? null : 1)} className="w-full flex items-center justify-between p-3 md:p-4 text-left group" data-id="element-91">
              <div className="flex items-center gap-3 flex-1" data-id="element-92">
                <span className="text-[#22c55e] font-bold text-sm md:text-base whitespace-nowrap" data-id="element-93">
                  2 —
                </span>
                <span className="font-bold text-white text-sm md:text-base" data-id="element-94">
                  ¿Sirve para todas las provincias de Argentina?
                </span>
              </div>
              <span className="text-gray-500 ml-3 flex-shrink-0 text-xs" data-id="element-95">
                {openIndex === 1 ? '▲' : '▼'}
              </span>
            </button>
            {openIndex === 1 && <div className="px-3 md:px-4 pb-3 md:pb-4 pt-0 ml-10 md:ml-12" data-id="element-96">
                <p className="text-gray-400 text-sm md:text-base leading-relaxed border-t border-gray-800 pt-3" data-id="element-97">
                  Sí, el contenido está alineado con los NAP 2026. Los ejes
                  temáticos de educación financiera son universales y se adaptan
                  a los diseños curriculares de todas las provincias argentinas.
                </p>
              </div>}
          </div>

          {/* FAQ 3 */}
          <div className="bg-[#111638] border border-gray-800 rounded-lg overflow-hidden transition-all duration-200" data-id="element-98">
            <button onClick={() => setOpenIndex(openIndex === 2 ? null : 2)} className="w-full flex items-center justify-between p-3 md:p-4 text-left group" data-id="element-99">
              <div className="flex items-center gap-3 flex-1" data-id="element-100">
                <span className="text-[#22c55e] font-bold text-sm md:text-base whitespace-nowrap" data-id="element-101">
                  3 —
                </span>
                <span className="font-bold text-white text-sm md:text-base" data-id="element-102">
                  ¿Es editable? ¿Puedo modificarlo?
                </span>
              </div>
              <span className="text-gray-500 ml-3 flex-shrink-0 text-xs" data-id="element-103">
                {openIndex === 2 ? '▲' : '▼'}
              </span>
            </button>
            {openIndex === 2 && <div className="px-3 md:px-4 pb-3 md:pb-4 pt-0 ml-10 md:ml-12" data-id="element-104">
                <p className="text-gray-400 text-sm md:text-base leading-relaxed border-t border-gray-800 pt-3" data-id="element-105">
                  El material viene en PDF listo para usar en clase. La
                  planificación anual viene en formato editable para que la
                  adaptes a tu institución y contexto particular.
                </p>
              </div>}
          </div>

          {/* FAQ 4 */}
          <div className="bg-[#111638] border border-gray-800 rounded-lg overflow-hidden transition-all duration-200" data-id="element-106">
            <button onClick={() => setOpenIndex(openIndex === 3 ? null : 3)} className="w-full flex items-center justify-between p-3 md:p-4 text-left group" data-id="element-107">
              <div className="flex items-center gap-3 flex-1" data-id="element-108">
                <span className="text-[#22c55e] font-bold text-sm md:text-base whitespace-nowrap" data-id="element-109">
                  4 —
                </span>
                <span className="font-bold text-white text-sm md:text-base" data-id="element-110">
                  ¿Los 4 bonos están incluidos en todas las ofertas?
                </span>
              </div>
              <span className="text-gray-500 ml-3 flex-shrink-0 text-xs" data-id="element-111">
                {openIndex === 3 ? '▲' : '▼'}
              </span>
            </button>
            {openIndex === 3 && <div className="px-3 md:px-4 pb-3 md:pb-4 pt-0 ml-10 md:ml-12" data-id="element-112">
                <p className="text-gray-400 text-sm md:text-base leading-relaxed border-t border-gray-800 pt-3" data-id="element-113">
                  Sí, tanto el Kit Completo como el Pack Premium incluyen los 4
                  bonos exclusivos de regalo.
                </p>
              </div>}
          </div>

          {/* FAQ 5 */}
          <div className="bg-[#111638] border border-gray-800 rounded-lg overflow-hidden transition-all duration-200" data-id="element-114">
            <button onClick={() => setOpenIndex(openIndex === 4 ? null : 4)} className="w-full flex items-center justify-between p-3 md:p-4 text-left group" data-id="element-115">
              <div className="flex items-center gap-3 flex-1" data-id="element-116">
                <span className="text-[#22c55e] font-bold text-sm md:text-base whitespace-nowrap" data-id="element-117">
                  5 —
                </span>
                <span className="font-bold text-white text-sm md:text-base" data-id="element-118">
                  ¿Necesito conocimientos previos de finanzas para usarlo?
                </span>
              </div>
              <span className="text-gray-500 ml-3 flex-shrink-0 text-xs" data-id="element-119">
                {openIndex === 4 ? '▲' : '▼'}
              </span>
            </button>
            {openIndex === 4 && <div className="px-3 md:px-4 pb-3 md:pb-4 pt-0 ml-10 md:ml-12" data-id="element-120">
                <p className="text-gray-400 text-sm md:text-base leading-relaxed border-t border-gray-800 pt-3" data-id="element-121">
                  No, todo está explicado paso a paso para el docente. No
                  necesitás ser economista ni experto en finanzas para dar
                  clases excelentes con este material.
                </p>
              </div>}
          </div>

          {/* FAQ 6 */}
          <div className="bg-[#111638] border border-gray-800 rounded-lg overflow-hidden transition-all duration-200" data-id="element-122">
            <button onClick={() => setOpenIndex(openIndex === 5 ? null : 5)} className="w-full flex items-center justify-between p-3 md:p-4 text-left group" data-id="element-123">
              <div className="flex items-center gap-3 flex-1" data-id="element-124">
                <span className="text-[#22c55e] font-bold text-sm md:text-base whitespace-nowrap" data-id="element-125">
                  6 —
                </span>
                <span className="font-bold text-white text-sm md:text-base" data-id="element-126">
                  ¿Funciona para escuelas con pocos recursos tecnológicos?
                </span>
              </div>
              <span className="text-gray-500 ml-3 flex-shrink-0 text-xs" data-id="element-127">
                {openIndex === 5 ? '▲' : '▼'}
              </span>
            </button>
            {openIndex === 5 && <div className="px-3 md:px-4 pb-3 md:pb-4 pt-0 ml-10 md:ml-12" data-id="element-128">
                <p className="text-gray-400 text-sm md:text-base leading-relaxed border-t border-gray-800 pt-3" data-id="element-129">
                  Sí, todo el material es imprimible. No necesitás proyector,
                  computadoras ni internet en el aula para implementar las
                  actividades.
                </p>
              </div>}
          </div>

          {/* FAQ 7 */}
          <div className="bg-[#111638] border border-gray-800 rounded-lg overflow-hidden transition-all duration-200" data-id="element-130">
            <button onClick={() => setOpenIndex(openIndex === 6 ? null : 6)} className="w-full flex items-center justify-between p-3 md:p-4 text-left group" data-id="element-131">
              <div className="flex items-center gap-3 flex-1" data-id="element-132">
                <span className="text-[#22c55e] font-bold text-sm md:text-base whitespace-nowrap" data-id="element-133">
                  7 —
                </span>
                <span className="font-bold text-white text-sm md:text-base" data-id="element-134">
                  ¿El contenido está actualizado con la economía argentina
                  actual?
                </span>
              </div>
              <span className="text-gray-500 ml-3 flex-shrink-0 text-xs" data-id="element-135">
                {openIndex === 6 ? '▲' : '▼'}
              </span>
            </button>
            {openIndex === 6 && <div className="px-3 md:px-4 pb-3 md:pb-4 pt-0 ml-10 md:ml-12" data-id="element-136">
                <p className="text-gray-400 text-sm md:text-base leading-relaxed border-t border-gray-800 pt-3" data-id="element-137">
                  Sí, está 100% actualizado para 2026. Incluye temas actuales
                  como billeteras virtuales (Mercado Pago), criptomonedas,
                  inflación, CEDEARs y estafas digitales modernas.
                </p>
              </div>}
          </div>

          {/* FAQ 8 */}
          <div className="bg-[#111638] border border-gray-800 rounded-lg overflow-hidden transition-all duration-200" data-id="element-138">
            <button onClick={() => setOpenIndex(openIndex === 7 ? null : 7)} className="w-full flex items-center justify-between p-3 md:p-4 text-left group" data-id="element-139">
              <div className="flex items-center gap-3 flex-1" data-id="element-140">
                <span className="text-[#22c55e] font-bold text-sm md:text-base whitespace-nowrap" data-id="element-141">
                  8 —
                </span>
                <span className="font-bold text-white text-sm md:text-base" data-id="element-142">
                  ¿Sirve para cursos difíciles o desinteresados?
                </span>
              </div>
              <span className="text-gray-500 ml-3 flex-shrink-0 text-xs" data-id="element-143">
                {openIndex === 7 ? '▲' : '▼'}
              </span>
            </button>
            {openIndex === 7 && <div className="px-3 md:px-4 pb-3 md:pb-4 pt-0 ml-10 md:ml-12" data-id="element-144">
                <p className="text-gray-400 text-sm md:text-base leading-relaxed border-t border-gray-800 pt-3" data-id="element-145">
                  Sí. Al usar ejemplos reales y locales que los chicos ven todos
                  los días, el nivel de interés y participación aumenta
                  drásticamente.
                </p>
              </div>}
          </div>

          {/* FAQ 9 */}
          <div className="bg-[#111638] border border-gray-800 rounded-lg overflow-hidden transition-all duration-200" data-id="element-146">
            <button onClick={() => setOpenIndex(openIndex === 8 ? null : 8)} className="w-full flex items-center justify-between p-3 md:p-4 text-left group" data-id="element-147">
              <div className="flex items-center gap-3 flex-1" data-id="element-148">
                <span className="text-[#22c55e] font-bold text-sm md:text-base whitespace-nowrap" data-id="element-149">
                  9 —
                </span>
                <span className="font-bold text-white text-sm md:text-base" data-id="element-150">
                  ¿Tiene garantía?
                </span>
              </div>
              <span className="text-gray-500 ml-3 flex-shrink-0 text-xs" data-id="element-151">
                {openIndex === 8 ? '▲' : '▼'}
              </span>
            </button>
            {openIndex === 8 && <div className="px-3 md:px-4 pb-3 md:pb-4 pt-0 ml-10 md:ml-12" data-id="element-152">
                <p className="text-gray-400 text-sm md:text-base leading-relaxed border-t border-gray-800 pt-3" data-id="element-153">
                  Sí. Tenés 7 días para revisar todo el material. Si no cumple
                  tus expectativas, te devolvemos el 100% del dinero. Sin
                  preguntas, sin vueltas.
                </p>
              </div>}
          </div>

          {/* FAQ 10 */}
          <div className="bg-[#111638] border border-gray-800 rounded-lg overflow-hidden transition-all duration-200" data-id="element-154">
            <button onClick={() => setOpenIndex(openIndex === 9 ? null : 9)} className="w-full flex items-center justify-between p-3 md:p-4 text-left group" data-id="element-155">
              <div className="flex items-center gap-3 flex-1" data-id="element-156">
                <span className="text-[#22c55e] font-bold text-sm md:text-base whitespace-nowrap" data-id="element-157">
                  10 —
                </span>
                <span className="font-bold text-white text-sm md:text-base" data-id="element-158">
                  ¿Qué diferencia tiene con otros materiales de educación
                  financiera?
                </span>
              </div>
              <span className="text-gray-500 ml-3 flex-shrink-0 text-xs" data-id="element-159">
                {openIndex === 9 ? '▲' : '▼'}
              </span>
            </button>
            {openIndex === 9 && <div className="px-3 md:px-4 pb-3 md:pb-4 pt-0 ml-10 md:ml-12" data-id="element-160">
                <p className="text-gray-400 text-sm md:text-base leading-relaxed border-t border-gray-800 pt-3" data-id="element-161">
                  Es un sistema completo, no actividades sueltas. Son 6 tomos
                  estructurados, 100% adaptados al contexto argentino, listos
                  para usar desde el día 1 sin preparación extra.
                </p>
              </div>}
          </div>
        </div>
      </div>
    </section>;
}